/**
 * Styled Components - Created by gustavomedina on 04/05/18.
 */
import styled from 'styled-components'
import Popover from 'antd/lib/popover'
import { BLUE, RED, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

type StyleProps = {
  onlyRead?: boolean
  secondary?: boolean
}

export const Container = styled.li`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: var(--spacing-16);
  width: 100%;
  padding: var(--spacing-24);
  background: ${({ secondary }: StyleProps) => secondary ? '#f8f6ff' : 'var(--neutral-white)'};
  @media (max-width: 767px) {
    margin-bottom: var(--spacing-16);
    padding: 16px;
  }
`

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 767px) {
    flex-direction: row;
    position: relative;
  }
`

export const UpsLabel = styled.div`
  font-size: 12px;
  background: #f9f8e5;
  width: fit-content;
  padding: 3px 12px;
  border-radius: 25px;
  margin-top: -16px;
  margin-left: 18px;
  display: flex;
  align-items: center;
  padding-left: 0;
  @media (max-width: 767px) {
    margin-top: 8px;
    margin-left: 4px;
    margin-bottom: -10px;
  }
`

export const UpsIcon = styled.img`
  max-width: 19px;
  border-radius: 25px;
  padding: 0px;
  margin-top: -3px;
  margin-bottom: -2px;
  margin-right: 6px;
  margin-left: -3px;
`

export const UspsIcon = styled.img`
  max-width: 30px;
  margin-top: -9px;
  margin-bottom: -8px;
  margin-right: 6px;
  margin-left: 6px;
`

export const TrackingLink = styled.a`
  color: #3887e3;
  margin-left: 4px;
  text-decoration: underline;
`

export const ItemDetailsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-left: var(--spacing-12);
  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  .designCode {
    color: var(--neutral-body);
    font: 600 12px/20px var(--font-barlow);
    letter-spacing: 1px;
  }
`

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 767px) {
    margin-top: var(--spacing-4);
    align-items: flex-start;
  }
`

export const ItemDetailsHeaderName = styled.div`
  overflow: hidden;
  color: var(--neutral-darkest);
  text-overflow: ellipsis;
  font: 600 20px/26px var(--font-barlow-semi-condensed);
  letter-spacing: 0.6px;
  @media (max-width: 767px) {
    font: 600 16px/22px var(--font-barlow);
  }
`

export const ItemDetailsHeaderNameDetail = styled.div`
  overflow: hidden;
  color: var(--neutral-body);
  text-overflow: ellipsis;
  font: 400 14px/22px var(--font-inter);
  margin-top: var(--spacing-8);

  @media (max-width: 767px) {
    margin-top: var(--spacing-4);
  }
`

export const ItemDetailsHeaderPrice = styled.div`
  color: var(--neutral-darkest);
  text-align: right;
  font: 600 20px/26px var(--font-barlow-semi-condensed);
  letter-spacing: 0.6px;
  @media (max-width: 767px) {
    text-align: left;
    font: 600 16px/22px var(--font-barlow);
  }
`

interface ItemDetailsHeaderProps {
  $highlighted?: boolean
  $lined?: boolean
}

export const ItemDetailsHeaderPriceDetail = styled.div`
  color: ${({ $highlighted }: ItemDetailsHeaderProps) =>
    $highlighted ? 'var(--accent-green)' : 'var(--neutral-body)'};
  text-align: right;
  font: 400 12px/18px var(--font-inter);
  text-decoration-line: ${({ $lined }: ItemDetailsHeaderProps) => $lined ? 'line-through' : 'none'};
  @media (max-width: 767px) {
    text-align: left;
  }
`

export const HeaderPriceDetailEmpty = styled.div`
  height: 14px;
  @media (max-width: 767px) {
    display: none;
  }
`

export const ItemDetailsContent = styled.div``

export const Image = styled.img`
  object-fit: cover;
  user-select: none;
  height: 136px;
  width: 102px;
  padding: 8px;
  border-radius: 3px;
  background: var(--lightened-cool);
  &:hover {
    cursor: pointer;
  }
`

export const FooterItem = styled.div`
  display: flex;
  padding-top: var(--spacing-12);
  justify-content: space-between;
  align-items: center;
  border-top: var(--border-regular) solid var(--neutral-border-light);
`

export const AddMore = styled.div`
  display: flex;
  padding: var(--spacing-8) var(--spacing-16);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-8);
  color: var(--neutral-darkest);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  border: var(--border-regular) solid var(--neutral-border-med);
  cursor: pointer;
  &:hover {
    border: var(--border-regular) solid var(--neutral-darkest);
    background: var(--neutral-fill-lightest);
  }
`

export const DeleteItem = styled.div`
  color: var(--neutral-secondary);
  font: 400 14px/20px var(--font-inter);
  text-decoration-line: underline;
  text-underline-offset: 10%;
  text-underline-position: from-font;
  transition: color .25s;
  &:hover {
    color: var(--neutral-darkest);
    cursor: pointer;
  }
`

export const FromTeamStore = styled.div`
  overflow: hidden;
  color: var(--neutral-body);
  text-overflow: ellipsis;
  font: 400 14px/22px var(--font-inter);
`

export const StoreLink = styled.div`
  display: inline-block;
  color: var(--neutral-darkest);
  text-decoration-line: underline;
  cursor: pointer;
`

export const TestPrintIcon = styled.img`
  max-width: 22px;
  position: absolute;
  left: 6px;
  z-index: 3;
  bottom: ${({ onlyRead }: StyleProps) => onlyRead ? '10px' : '6px'};
  @media (max-width: 767px) {
    bottom: 48px;
  }
`

export const ImageContainer = styled.div`
  position: relative;
`

export const QtyTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-4);
  margin-top: var(--spacing-8);

  .qtyLabel {
    font: 600 12px/20px var(--font-barlow);
    color: var(--neutral-body);
  }

  .qtyBadge {
    padding: 3px 10px;
    border-radius: 25px;
    background-color: var(--neutral-dark-gray);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font: 400 12px/18px var(--font-inter);
  }
`

export const StatusFlag = styled.img`
  position: absolute;
  height: 38px;
  right: 0;
  z-index: 8;
  @media (max-width: 767px) {
    height: 32px;
  }
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const TooltipContentModal = styled.div`
  max-width: 398px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const buttonStyle = {
  boxShadow: 'none',
  border: 'none',
  background: 'none',
  color: RED
}

export const TicketDiv = styled.div`
  font-size: 11px;
  display: flex;
  padding-left: 16px;
  flex-flow: column-reverse;
  align-items: flex-start;
`

export const TicketLink = styled.a`
  font-size: 14px;
  margin-bottom: 2px;
  color: ${BLUE};
`

export const TestPrintDiv = styled.div`
  position: absolute;
  left: 8px;
  z-index: 3;
  bottom: ${({ onlyRead }: StyleProps) => onlyRead ? '5px' : '6px'};
  @media (max-width: 767px) {
    bottom: 48px;
  }
`

export const PlusSign = styled(Icon)`
  position: absolute;
  right: -3px;
  top: -3px;
  font-size: 10px;
  filter: brightness(1.2);
  z-index: 2;
`

export const PrintIcon = styled.img`
  max-width: 26px;
  object-fit: contain;
  opacity: 0.7;
  background: ${WHITE};
  padding: 4px;
  border-radius: 25px;
  border-bottom-left-radius: 0px;
`

export const CircleIcon = styled(Icon)`
  max-width: 26px;
  object-fit: contain;
  opacity: 0.8;
  background: ${WHITE};
  padding: 4px;
  border-radius: 25px;
  border-bottom-left-radius: 0px;
`

export const NotesDiv = styled.div`
  color: #736b99;
  font-size: 13px;
`

export const NotesTitle = styled.div`
  font-weight: bold;
  color: #7e789c;
`

export const EditIcon = styled(Icon)`
  transition: all .25s;
  margin-right: 6px;
  color: rebeccapurple;
  transition: all .25s;
`

export const NotesDivMobile = styled.div`
  margin-left: 18px;
  margin-top: 10px;
  color: #8a80bc;
  font-size: 13px;
  display: none;
  @media (max-width: 767px) {
    display: flex;
    margin: 0;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemV2/styledComponents.tsx